import React, { useEffect, useState } from "react";
import DefaultLayout from "../../Layouts/DefaultLayout";
import { useStoreContext } from "../../Contexts/StoreContext";
import DefaultLayoutProfile from "../../Layouts/DefaultLayoutProfile";
import CardProfileAddresses from "../../Components/Layout/Profile/CardProfileAddresses";
import CardProfileOrders from "../../Components/Layout/Profile/CardProfileOrders";
import CardProfileBasicInfo from "../../Components/Layout/Profile/CardProfileBasicInfo";
import CardBoxDefault from "../../Components/Layout/CardBoxDefault";
import CustomerService from "../../Services/CustomerService";
import { useOrderTypeContext } from "../../Contexts/OrderTypeContext";
import { useTranslation } from "react-i18next";

const ProfileHome = () => {
    
    const { t } = useTranslation();
    document.title = t('profile.page_title');

    const { currentStore } = useStoreContext();
    const { orderType } = useOrderTypeContext();
    const [ loadingMainInfo, setLoadingMainInfo ] = useState<boolean>(false);
    const [ ordersList, setOrdersList ] = useState<any[]>([]);
    const [ addressesList, setAddressesList ] = useState<any[]>([]);

    const getMainInfo = async () => {
        try {
            setLoadingMainInfo(true);

            const customerService = new CustomerService(orderType);
            const mainInfo = await customerService.getMainInfo();

            if (mainInfo) {
                setOrdersList(mainInfo.orders);
                setAddressesList(mainInfo.addresses);
            } else {
                setOrdersList([]);
                setAddressesList([]);
            }
        }
        catch (error: any) {}
        finally {
            setLoadingMainInfo(false);
        }
    }

    useEffect(() => {
        getMainInfo();
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, []);


    return (
        <DefaultLayout showHeader={currentStore}>
            <DefaultLayoutProfile>

                <section className="grid h-full gap-4 lg:grid-cols-2 text-sm">
                    <CardBoxDefault>
                        <CardProfileBasicInfo />
                    </CardBoxDefault>

                    <CardBoxDefault className="row-span-2">
                        <CardProfileOrders loading={loadingMainInfo} list={ordersList} />
                    </CardBoxDefault>

                    <CardBoxDefault>
                        <CardProfileAddresses loading={loadingMainInfo} list={addressesList} />
                    </CardBoxDefault>

                    {/* <CardBoxDefault>
                        <CardProfileCards />
                    </CardBoxDefault> */}
                </section>

            </DefaultLayoutProfile>
        </DefaultLayout>
    );
};

export default ProfileHome;